import styled, { css } from 'styled-components';

import {
  ThemeProps as Prop, Components, Breakpoints, AlertColorMap, AlertType, StaticProfiles,
} from '@powdr/constants';
import { componentColor } from '@powdr/utils';

const CPNT = Components.ALERT_BAR;

const getColor = (colorOverride, prop) => componentColor(
  (colorOverride)
    ? AlertColorMap[colorOverride][prop]
    : AlertColorMap[AlertType.INFO][prop],
  CPNT,
  prop,
  (colorOverride !== AlertType.INFO && colorOverride) && StaticProfiles.ALERTS,
);

export const StyledAlertBar = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  background-color: ${({ $alertType }) => getColor($alertType, Prop.BACKGROUND)};
  position: relative;
  overflow: hidden;
  pointer-events: all;

  .alert-content-wrapper {
    height: fit-content;
  }

  .alert-content {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: fit-content;
    padding: 10px 30px 10px 30px;

    .alert-html {
      margin-bottom: 0;
      width: 100%;
      line-height: 1.2;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
        margin-bottom: 0;
        font-size: 16px;

        ${Breakpoints.mobile(css`
          font-size: 13px;
        `)}

        ${Breakpoints.small(css`
          font-size: 14px;
        `)}
      }

      p {
        color: ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
        margin-bottom: 0;
        font-size: 16px;

        ${Breakpoints.small(css`
          font-size: 14px;
        `)}

        ${Breakpoints.mobile(css`
          font-size: 13px;
        `)}
      }

      a {
        color: ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
        text-decoration: underline;
        transition: color 0.2s linear;

        &:focus {
          outline: 2px solid ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
          outline-offset: 0.2em;
        }
      }
    }

    .close {
      display: block;
      margin-left: 10px;

      svg {
        transition: fill 0.2s linear;
        fill: ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
        color: ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
      }

      &:focus {
        outline: 2px solid ${({ $alertType }) => getColor($alertType, Prop.CONTENT)};
        outline-offset: 0.2em;
      }
    }
  }
`;
